import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NewsService } from '../../services/news.service';
import notify from 'devextreme/ui/notify';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-registro-rendicion',
  templateUrl: './registro-rendicion.component.html',
  styleUrls: ['./registro-rendicion.component.css']
})
export class RegistroRendicionComponent implements OnInit {

  public form: FormGroup;
  private formSumitAttempt: boolean;
  public evento;
  public enlace;
  siteKey:string;
  constructor(private formBuilder: FormBuilder, private servicio: NewsService, public sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.siteKey = '6LfE_EgaAAAAAIDOqD9DJL08pvOANZFZDyXJiE3g';
    this.form = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      cedula_identidad: ['', [Validators.required]],
      cargo: ['', [Validators.required]],
      institucion: ['', [Validators.required]],
      telefono: ['', [Validators.required]],
      correo: ['', [Validators.required, Validators.email]],
      recaptcha: ['', Validators.required]
    });
    this.servicio.evento().subscribe(res => {
      this.evento = res;
      this.enlace = this.sanitizer.bypassSecurityTrustResourceUrl(res.enlace_evento);
    });
  }

  submit() {
    this.formSumitAttempt = true;
    if (this.form.valid) {
      const data = this.form.getRawValue();
      this.servicio.register(data).subscribe((res: any) => {
        this.formSumitAttempt = false;
        notify({
          message: "Se realizó el registro con éxito. En unos minutos mas le enviaremos el enlace para acceder al evento",
          position: {
              my: "center top",
              at: "center top"
          }
        }, "success", 9000);
        this.form.reset();
      });
    }

  }

  isFieldValid(field: string) {
		if (this.form.get(field).valid && this.formSumitAttempt) return false;
		else
			return (
				(this.form.get(field).invalid && this.form.get(field).dirty) ||
				(this.form.get(field).untouched && this.formSumitAttempt)
			);
	}

  get nombre() { return this.form.get('nombre');}
  get cedula_identidad() { return this.form.get('cedula_identidad');}
  get cargo() { return this.form.get('cargo');}
  get institucion() { return this.form.get('institucion');}
  get telefono() { return this.form.get('telefono');}
  get correo() { return this.form.get('correo');}

}



// WEBPACK FOOTER //
// ./src/app/components/registro-rendicion/registro-rendicion.component.ts